import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Copy, Box, Flex, themeColor } from '@elparking/components'
import Routes from 'commons/js/routes/routes'

import Thumbnail from './Thumbnail'
import { trackTealiumEvent, ViatShopEvents } from 'commons/js/services/analytics'

const DEFAULT_PARKING_IMAGE_URL = '/images/parking/default_gray_medium.webp'

const CoverImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`

const BorderBox = styled(Box)`
    border: 1px solid ${themeColor('gray20')};
`

const OverflowBox = styled(Box)`
    overflow: hidden;
`

const parkingUrl = ({ id: idParking, slug, province }) => (
    Routes.parkingPath({
        idParking,
        slug,
        province: province.slug,
    })
)

const ListItemContent = ({ item }) => (
    <BorderBox dataTest='list-item'>
        <Flex>
            <OverflowBox flex='0 1 auto' width='86px' height='88px'>
                <Thumbnail
                  url={item.media.regular}
                  fallbackUrl={DEFAULT_PARKING_IMAGE_URL}
                  imageComponent={CoverImage}
                />
            </OverflowBox>
            <Flex flexWrap='wrap' flex='1' p='12px' minWidth='0'>
                <Box width='100%'>
                    <Copy.truncate padding='0' color='main' size='medium' fontWeight='book'>
                        {item.name}
                    </Copy.truncate>
                </Box>
                <Box width='100%'>
                    <Copy.truncate padding='0' color='gray' size='xSmall' fontWeight='regular'>
                        {item.address}
                    </Copy.truncate>
                </Box>
                <Box width='100%'>
                    <Copy.truncate padding='0' color='gray' size='small' fontWeight='book'>
                        {item.province.name}
                    </Copy.truncate>
                </Box>
            </Flex>
        </Flex>
    </BorderBox>
)

ListItemContent.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        address: PropTypes.string,
        province: PropTypes.shape({
            name: PropTypes.string,
            slug: PropTypes.string,
        }),
        slug: PropTypes.string,
        media: PropTypes.shape({
            regular: PropTypes.string,
        }),
    }),
}

const ListItem = React.memo(({ item, isLinkable }) => {
    if (isLinkable) {
        return (
            <a onClick={() => trackTealiumEvent(ViatShopEvents.trackParkingDetailByView(item.name))} rel='noopener noreferrer' target='_blank' href={parkingUrl(item)}>
                <ListItemContent item={item} />
            </a>
        )
    }

    return <ListItemContent item={item} />
})

ListItem.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        address: PropTypes.string,
        province: PropTypes.shape({
            name: PropTypes.string,
            slug: PropTypes.string,
        }),
        slug: PropTypes.string,
        media: PropTypes.shape({
            regular: PropTypes.string,
        }),
    }),
    isLinkable: PropTypes.bool,
}

export default ListItem
